module.exports = __webpack_public_path__ + "img/d05.cd58f163.jpg";